import { render, staticRenderFns } from "./CommissionOverviewPage.vue?vue&type=template&id=f6b0ed5c&"
import script from "./CommissionOverviewPage.vue?vue&type=script&lang=js&"
export * from "./CommissionOverviewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports